import { useDocumentTitle } from "../../hooks";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import BackendLayout from "../../layouts/BackendLayout";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { INSPECTION_SHEET, INSPECTION_STATUS } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { errorStatusHandle, hasError } from "../../utils";
import {
  ButtonDownloadFile,
  ButtonFilterSearch,
  ModalInspection,
  PageAlert,
  RadioInput,
  ButtonHelp,
  ButtonDPad, RedirectAlert,
} from "../../components";
import ScrollModalButtons from "../../components/ScrollModalButtons"
import InputLabel from "../../components/InputLabel";
import Select2 from "../../components/Select2";
import ButtonHide from "../../components/buttons/ButtonHide";
import { Tabs } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import Table from "../../components/table/Table";
import { range } from "../../utils/array-utils";
import TableBody from "../../components/table/TableBody";
import InspectionResult from "./InspectionResult";
import JudgmentResult from "./JudgmentResult";
import {
  useInspectionStatusData,
  useInspectionStatusPage,
} from "../../hooks/InspectionStatusHook";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import { updateUserSetting } from "../../services/user-master/UserSettingServices";
import { InspectionStatusModalHelp } from "../../containers/inspection-status";
import {
  formatYearMonthInJapaneseText,
  getPreviousMonth,
} from "../../utils/datetime-utils";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { API_INSPECTION_STATUS_DOWNLOAD } from "../../constants/api";
import {INSPECTION_STATUS_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function InspectionStatus(props) {
  useRedirectPage(INSPECTION_STATUS_PAGE);
  useDocumentTitle("点検状況 - 点検王");
  const breadcrumb = getRouteBreadcrumb(INSPECTION_STATUS);
  const [hiddenTitle, setHiddenTitle] = useState(false);
  const [hiddenForm, setHiddenForm] = useState(false);
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const inspectionStatusSettings = useSelector(s => s.app_settings.inspection_status)
  const {
    dates,
    inspectionStatus,
    setInspectionStatus,
    params,
    setParams,
    errors,
  } = useInspectionStatusData();
  const { filterList, filterGroupsOptions, setFilterList, templateOptions } =
    useInspectionStatusPage(setParams);
  const tabRef = useRef(null);
  const [showInspectModal, setShowInspectModal] = useState(false);
  const inspectionSymbol = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const [panelState, setPanelState] = useState({
    day: 0,
    machine: "",
    dailyJudgment: false,
    monthlyJudgment: false,
    dailyInspection: false,
    inspection: null,
    workflow: null,
  });
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {});

  const handleChangeFilter = (e, name) => {
    const newFilter = {
      ...filterList,
      [name]: e,
    };
    if (name !== "template") {
      newFilter.template = { value: null, label: "[ALL]" };
    }
    setFilterList(newFilter);
  };

  const updateSettings = async (data) => {
    try {
      await updateUserSetting(data, USER_SETTING_CATEGORIES.INSPECTION_STATUS);
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleSearch = () => {
    tabRef.current?.setActiveTab(0);
    setInspectionStatus({});
    setParams({
      group_1: filterList[1]?.value,
      group_2: filterList[2]?.value,
      group_3: filterList[3]?.value,
      group_4: filterList[4]?.value,
      group_5: filterList[5]?.value,
      month: filterList.month,
      template: filterList.template?.value ?? null,
    });
    updateSettings({ ...filterList, selected_group: null });
  };

  const handleCloseModal = () => {
    setPanelState((state) => ({
      ...state,
      day: 0,
      dailyJudgment: false,
      monthlyJudgment: false,
      dailyInspection: false,
      inspection: null,
      workflow: null,
      machine: null,
    }));
  };

  const navigate = useNavigate();
  const RedirectInspectionSheetScreen = (machineStatus, month) => {
    const link = `${INSPECTION_SHEET}?machine=${machineStatus.machine.id}&template=${machineStatus.template.id}&month=${month}`;
    navigate(link, { state: { from: "InspectionStatus" } });
  };

  return (
    <BackendLayout
      sidebar={true}
      breadcrumb={breadcrumb}
      showHeader={showHeader}
    >
      <ButtonDPad />
      <div className={hiddenTitle ? "hidden" : ""}>
        <PageTitle title="点検状況" />
        <RedirectAlert />
        <PageAlert />
        {groupSettings.group_3.active === false && (
          <div className="p-3 rounded-lg text-[#9c2020] bg-[#fdf0f0] border border-[#f6abac]">
            設備グループの数が不足しているためページを表示することが出来ません
          </div>
        )}
      </div>
      {groupSettings.group_3.active && (
        <>
          <div className="w-full min-w-[1450px] relative">
            {hiddenForm && (
              <ButtonHide
                className="-top-[36px] left-[872px]"
                hidden={hiddenForm}
                onClick={() => {
                  setHiddenForm(false);
                  setHiddenTitle(false);
                  setShowHeader(true);
                }}
              />
            )}
            <div
              className="w-fit relative"
              style={hiddenForm ? { height: 0, overflow: "hidden" } : {}}
            >
              {!hiddenForm && (
                <ButtonHide
                  className="top-100 -right-[36px]"
                  hidden={hiddenTitle}
                  onClick={() => {
                    setHiddenTitle(!hiddenTitle);
                    setShowHeader(!showHeader);
                  }}
                />
              )}
              <ButtonHide
                className="-bottom-[36px] -right-[36px]"
                hidden={hiddenForm}
                onClick={() => {
                  setHiddenForm(!hiddenForm);
                  setHiddenTitle(true);
                  setShowHeader(false);
                }}
              />
              <form className="flex flex-row items-start gap-[20px] w-full p-[20px] bg-white md:mr-2.5 xl:mr-[22px] border border-tenken-gray-300 mt-2 rounded-lg">
                {range(1, 5).map(
                  (level) =>
                    groupSettings[`group_${level}`].active && (
                      <div className="w-fit" key={level}>
                        <label className="judgment__search--label whitespace-nowrap">
                          {groupSettings[`group_${level}`].name}
                        </label>
                        <Select2
                          nextFocus={
                            groupSettings[`group_${level + 1}`]?.active
                              ? `group_${level}_id`
                              : null
                          }
                          className="mt-[14px] w-full lg:min-w-[180px] min-w-[160px] lg:max-w-[240px] max-w-[228px]"
                          hasError={hasError(errors, `group_${level}`)}
                          classNamePrefix="react-select"
                          value={filterList[level]}
                          options={filterGroupsOptions[level]}
                          onChange={(e) => handleChangeFilter(e, level)}
                          name={`group_${level}`}
                          maxLength={30}
                          placeholder={groupSettings[`group_${level}`].name}
                        />
                      </div>
                    )
                )}
                <div className="w-fit">
                  <label className="judgment__search--label whitespace-nowrap">
                    点検テンプレート名
                  </label>
                  <Select2
                    className="mt-[14px] lg:min-w-[200px] min-w-[180px] lg:max-w-[240px] max-w-[228px]"
                    hasError={hasError(errors, `template`)}
                    classNamePrefix="react-select"
                    value={filterList["template"]}
                    options={templateOptions}
                    onChange={(e) => handleChangeFilter(e, "template")}
                    name={`template`}
                    maxLength={30}
                    placeholder="点検テンプレート名"
                  />
                </div>
                <div className="w-[80px]">
                  <InputLabel
                    className="judgment__search--label whitespace-nowrap"
                    text="表示対象"
                  />
                  <div className="mt-[4px]">
                    <div>
                      <RadioInput
                        className="small-type"
                        isSmall={true}
                        label="先月"
                        checked={filterList.month === "last_month"}
                        value="last_month"
                        id="last_month"
                        onChange={() =>
                          setFilterList((filterList) => ({
                            ...filterList,
                            month: "last_month",
                          }))
                        }
                      />
                    </div>
                    <div className="mt-[4px]">
                      <RadioInput
                        className="small-type"
                        isSmall={true}
                        label="今月"
                        checked={filterList.month === "this_month"}
                        value="this_month"
                        id="this_month"
                        onChange={() =>
                          setFilterList((filterList) => ({
                            ...filterList,
                            month: "this_month",
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col">
                  <div className="h-7"></div>
                  <ButtonFilterSearch
                    onClick={handleSearch}
                    className="mt-[10px]"
                    id="btn-search-judgment"
                    text="検索実行"
                  />
                </div>
              </form>
            </div>
            {inspectionStatus.length > 0 && (
              <>
                <div className="flex flex-row gap-[20px] items-start mt-[24px]">
                  <label className="lg:text-[26px] text-2xl py-1 font-bold">
                    {formatYearMonthInJapaneseText(
                      params.month === "this_month"
                        ? new Date()
                        : getPreviousMonth()
                    )}
                  </label>
                  <ButtonHelp
                    color="reset"
                    className="px-8"
                    onClick={() => setOpenModalHelp(true)}
                  >
                    凡例
                  </ButtonHelp>
                  <ButtonDownloadFile
                    id="download-inspection-status"
                    url={API_INSPECTION_STATUS_DOWNLOAD}
                    params={params}
                  ></ButtonDownloadFile>
                </div>
                <div className="pt-[24px] w-fit pr-7">
                  <Tabs
                    style="pills"
                    theme={tenkenTheme.tabs}
                    ref={tabRef}
                    // onActiveTabChange={(e) => handleTabsChange(e)}
                  >
                    {inspectionStatus.map(
                      (status) =>
                        (status.workflow.frequency !== 3 ||
                          inspectionStatusSettings.monthly_approval_status) && (
                          <Tabs.Item
                            title={status.workflow.name}
                            // active={params?.selected_group === status.workflow.id}
                          >
                            <div className="w-fit relative">
                              <LoadingSpinner component="inspection_status_table" />
                              <Table>
                                <TableBody>
                                  <Table.Row className="bg-tenken-gray-300">
                                    <Table.Cell
                                      className="!p-1 text-center border border-tenken-gray-500 whitespace-nowrap !rounded-none text-normal"
                                      rowSpan={2}
                                    >
                                      設備No.
                                    </Table.Cell>
                                    {range(1, dates).map((day, i) => (
                                      <Table.Cell
                                        className="!py-1 !px-3 text-center border border-tenken-gray-500 whitespace-nowrap !rounded-none text-normal min-w-[44px]"
                                        colSpan={
                                          inspectionStatusSettings.daily_approval_status
                                            ? 2
                                            : 1
                                        }
                                        key={i}
                                      >
                                        {day}
                                      </Table.Cell>
                                    ))}
                                  </Table.Row>
                                  <Table.Row className="bg-tenken-gray-300">
                                    {range(
                                      1,
                                      dates *
                                        (inspectionStatusSettings.daily_approval_status
                                          ? 2
                                          : 1)
                                    ).map((i) => (
                                      <Table.Cell
                                        className="!py-1 !px-[7.5px] border border-tenken-gray-500 text-center whitespace-nowrap text-sm"
                                        key={i}
                                      >
                                        {i %
                                          (inspectionStatusSettings.daily_approval_status
                                            ? 2
                                            : 1) ===
                                        (inspectionStatusSettings.daily_approval_status
                                          ? 1
                                          : 0) ? (
                                          <span className="w-4">点</span>
                                        ) : (
                                          <span className="w-4">承</span>
                                        )}
                                      </Table.Cell>
                                    ))}
                                  </Table.Row>
                                  {status.machine_status &&
                                    status.machine_status.length > 0 &&
                                    status.machine_status.map(
                                      (machineStatus) =>
                                        machineStatus.template.id !== null && (
                                          <Table.Row>
                                            <Table.Cell
                                              className={`!py-1 border border-tenken-gray-500 !rounded-none cursor-pointer max-w-[400px] truncate bg-white hover:bg-[#feec88] ${
                                                panelState?.machine ===
                                                machineStatus.machine.id
                                                  ? "bg-[#feec88]"
                                                  : ""
                                              }`}
                                              onClick={() =>
                                                RedirectInspectionSheetScreen(
                                                  machineStatus,
                                                  params?.month
                                                )
                                              }
                                            >
                                              <span
                                                title={
                                                  machineStatus.machine.name
                                                }
                                                className="overflow-hidden cursor-pointer text-blue-500"
                                              >
                                                {machineStatus.machine.name}
                                              </span>
                                            </Table.Cell>
                                            {machineStatus.daily_results
                                              ? machineStatus.daily_results.map(
                                                  (dayResult, i) => (
                                                    <Table.Cell
                                                      className="border border-tenken-gray-500 whitespace-nowrap !p-0 !rounded-none"
                                                      colSpan={
                                                        inspectionStatusSettings.daily_approval_status
                                                          ? 2
                                                          : 1
                                                      }
                                                      key={i}
                                                    >
                                                      <div className="flex gap-0 justify-evenly h-[40px]">
                                                        <InspectionResult
                                                          result={dayResult}
                                                          setShowModal={
                                                            setShowInspectModal
                                                          }
                                                          setPanelState={
                                                            setPanelState
                                                          }
                                                          machine={
                                                            machineStatus
                                                              .machine?.id
                                                          }
                                                          panelState={
                                                            panelState
                                                          }
                                                        ></InspectionResult>
                                                        {inspectionStatusSettings.daily_approval_status && (
                                                          <JudgmentResult
                                                            result={dayResult}
                                                            machine={
                                                              machineStatus
                                                                .machine?.id
                                                            }
                                                            remaining={
                                                              dayResult?.judgment_remaining
                                                            }
                                                            panelState={
                                                              panelState
                                                            }
                                                            setPanelState={
                                                              setPanelState
                                                            }
                                                            setShowModal={
                                                              setShowInspectModal
                                                            }
                                                            type="daily"
                                                          ></JudgmentResult>
                                                        )}
                                                      </div>
                                                    </Table.Cell>
                                                  )
                                                )
                                              : ""}
                                          </Table.Row>
                                        )
                                    )}
                                  {(!status.machine_status ||
                                    status.machine_status.length === 0) && (
                                    <Table.Cell
                                      colSpan={66}
                                      className="border border-tenken-gray-500 whitespace-nowrap !rounded-none text-normal"
                                    >
                                      該当する点検履歴が見つかりませんでした。別の検索条件をお試しください。
                                    </Table.Cell>
                                  )}
                                </TableBody>
                              </Table>
                            </div>
                          </Tabs.Item>
                        )
                    )}
                  </Tabs>
                </div>
              </>
            )}
          </div>
          {showInspectModal && (
            <>
              <ModalInspection
                showModal={showInspectModal}
                setShowModal={setShowInspectModal}
                inspection={panelState.inspection}
                workflow={panelState?.workflow}
                onClose={handleCloseModal}
              />
              <ScrollModalButtons/>
            </>
          )}

          <InspectionStatusModalHelp
            openModal={openModalHelp}
            setOpenModal={setOpenModalHelp}
            inspectionSymbol={inspectionSymbol}
          />
        </>
      )}
    </BackendLayout>
  );
}
